import React from 'react';
import { WIcon } from '@warp-ds/components/react/icon';

interface AdImageProps {
  imageUrl: string | undefined;
  widthPx: number;
  heightPx: number;
}

function getBaseUrl(location: Location): string {
  // TODO make based on environment-config instead of hostname
  // Hack to show image by env until we agree on API format
  switch (location.hostname) {
    case 'www.finn.no':
      return 'https://images.finncdn.no/';
    case 'dev.finn.no':
    case 'local.finn.no':
      return 'https://dev-images.finncdn.no/';
    case 'www.tori.fi':
      return 'https://img.tori.net/';
    case 'dev.tori.fi':
    case 'local.tori.fi':
      return 'https://images.beta.tori.fi/';
    case 'www.dba.dk':
      return 'https://images.dbastatic.dk/';
    case 'dev.dba.dk':
    case 'local.dba.dk':
      return 'https://dev.images.dbastatic.dk/';
    case 'dev.blocket.se':
    case 'local.blocket.se':
      return 'https://images.dev.blocketcdn.se/';
    case 'www.blocket.se':
      return 'https://images.blocketcdn.se/';
    default:
      return 'https://dev-images.finncdn.no/';
  }
}

function getImageStyle(
  url: string | undefined,
  widthPx: number,
  heightPx: number,
) {
  const imageStyle: { [index: string]: string } = {
    backgroundSize: 'contain',
    width: `${widthPx}px`,
    height: `${heightPx}px`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
  };
  const baseUrl = getBaseUrl(window.location);
  imageStyle.backgroundImage = `url('${baseUrl}dynamic/480w/${url}')`;
  imageStyle.backgroundSize = 'cover';

  return imageStyle;
}

export default function AdImage({
  imageUrl,
  widthPx,
  heightPx,
}: AdImageProps) {
  if (imageUrl) {
    return (
      <div
        className="rounded-4 s-bg-subtle"
        style={getImageStyle(imageUrl, widthPx, heightPx)}
      />
    );
  }

  return (
    <div
      className="rounded-4 s-bg-subtle"
      style={{
        width: `${widthPx}px`, height: `${heightPx}px`, display: 'grid', placeItems: 'center',
      }}
    >
      <WIcon name="Image" size="large" className="s-icon-subtle" />
    </div>
  );
}
